import { useState } from "react";
import IconRelation from "../../components/icons/IconRelation";
import IconDelete from "../../components/icons/IconDelete";

export default function EstimationFunctionButton({ conversation, estimationFunctions, estimationGroups, onUpdateConversation, onAddGroup, onRemoveGroup }) {
    const [isOpen, setIsOpen] = useState(false);
    const [newGroupName, setNewGroupName] = useState("");

    const handleAddGroup = () => {
        onAddGroup(newGroupName).then(() => setNewGroupName(""));
    };

    return (
        <div className="functional-panelbutton toolbar-popup-anchor" onClick={() => setIsOpen((prev) => !prev)}>
            <IconRelation fillColor="icon-orange" style={{ height: 20, width: 20 }} />

            {isOpen ? (
                <div className="toolbar-popup" onClick={(e) => e.stopPropagation()}>
                    <p className="toolbar-popup-title">Функція оцінки</p>

                    <select
                        value={conversation?.estimationFunction?.id ?? ""}
                        onChange={(e) => onUpdateConversation({ estimationFunction: Number(e.target.value) })}
                    >
                        <option value="" disabled>
                            Оберіть функцію
                        </option>
                        {estimationFunctions.map((fn) => (
                            <option key={fn.id} value={fn.id}>
                                {fn.name}
                            </option>
                        ))}
                    </select>

                    <p className="toolbar-popup-subtitle">Групи оцінки цієї розмови</p>
                    <ul className="toolbar-popup-list">
                        {(estimationGroups || []).map((group) => (
                            <li key={group.id}>
                                <span>{group.name}</span>
                                <div className="toolbar-popup-list-delete" onClick={() => onRemoveGroup(group.id)}>
                                    <IconDelete fillColor="icon-red" style={{ height: 16, width: 16 }} />
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="toolbar-popup-add-row">
                        <input
                            value={newGroupName}
                            placeholder="Нова група..."
                            onChange={(e) => setNewGroupName(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleAddGroup()}
                        />
                        <button type="button" onClick={handleAddGroup}>
                            +
                        </button>
                    </div>
                </div>
            ) : (
                ""
            )}
        </div>
    );
}
